import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const {
  REMOVE_PTO_REQ_SUCCESS,
  REMOVE_PTO_REQ_FAILURE,
  REMOVE_PTO_REQ_RESET,
  REMOVE_PTO_REQ_LOADER,
} = getMyAvailabilityConstants;

const intitialstate: object = {
  isRemoved: false,
  response: null,
  loader: false,
};

export const removePtoRequestReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case REMOVE_PTO_REQ_SUCCESS: {
      return {
        ...state,
        isRemoved: true,
        response: action.payload,
        loader: false,
      };
    }

    case REMOVE_PTO_REQ_FAILURE:
      return {
        ...state,
        isRemoved: false,
        response: action.payload,
        loader: false,
      };

    case REMOVE_PTO_REQ_LOADER:
      return {
        ...state,
        loader: true,
      };

    case REMOVE_PTO_REQ_RESET:
      return intitialstate;

    default:
      return state;
  }
};
